import logo from "@/assets/img/logo.png?format=png;webp;avif&as=picture&imagetools"
import Image from "./Image"
import clsx from "clsx"

const Logo = ({
  heightClassName = "h-[30px]",
}: {
  heightClassName?: string
}) => (
  <Image
    image={logo}
    alt=""
    width={153}
    height={30}
    className={clsx("w-auto object-contain", heightClassName)}
    sizes="153px"
    priority
  />
)

export default Logo
